/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { WorkAreaInfo } from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class WorkAreaClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags WorkArea
   * @summary Получить все рабочие области
   * @request GET:/project/WorkArea
   * @secure
   */
  workAreaGetAllWorkAreas = (params: RequestParams = {}) =>
    this.http.request<WorkAreaInfo[], any>({
      path: `/project/WorkArea`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags WorkArea
   * @summary Добавить рабочую область
   * @request POST:/project/WorkArea
   * @secure
   */
  workAreaAddWorkArea = (data: WorkAreaInfo, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/project/WorkArea`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags WorkArea
   * @summary Получить настройки рабочей области по идектификатору
   * @request GET:/project/WorkArea/configById/{workAreaId}
   * @secure
   */
  workAreaGetWorkAreaConfigById = (workAreaId: string, params: RequestParams = {}) =>
    this.http.request<string, any>({
      path: `/project/WorkArea/configById/${workAreaId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags WorkArea
   * @summary Изменить настройки рабочей области
   * @request PUT:/project/WorkArea/updateConfig
   * @secure
   */
  workAreaUpdateWorkAreaConfig = (
    query: {
      /**
       * Идентификатор рабочаей области
       * @format uuid
       */
      workAreaId: string
    },
    data: string,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/project/WorkArea/updateConfig`,
      method: 'PUT',
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })
}
